import styled from "styled-components";

export const ArrowheadIconWrapper = styled.div``